<template>
  <section>
    <land-banner
      :items="banItems"
      :height="classify.height"
      :points="classify.points"
      :cycle="classify.cycle"
      :interval="classify.interval"
      :hide-delimiters="wdHideDelimiters"
      :show-arrows="wdShowArrows"
      @click="onClick"
    />
    <land-section
      id="hotcenter"
      space="40"
    >
      <v-container
        style="max-width: 1200px;"
      >
        <v-card
          class="mb-6"
          color="transparent"
          flat
          tile
        >
          <v-tabs
            v-model="currTab"
            background-color="transparent"
            class="d-flex flex-row justify-center align-center"
          >
            <v-tab
              v-for="(tab, tabIndex) in tabList"
              :key="tabIndex"
              :value="tab.name"
              :href="`#${tab.name}`"
              class="text-h6"
            >
              {{ tab.title }}
            </v-tab>
          </v-tabs>
        </v-card>
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
          >
            <v-tabs-items v-model="currTab">
              <v-tab-item
                v-for="(tab, tabIndex) in tabList"
                :key="tabIndex"
                :value="tab.name"
                class="rounded grey lighten-4"
              >
                <land-gallery
                  v-if="tab.items.length"
                  :items="tab.items"
                  :type="tab.type"
                  :ratio="tab.ratio"
                  :tooled="tab.tooled"
                  :margin="tab.margin"
                  @click="onContent($event, tab)"
                />
                <!-- <div
                  v-else
                  class="co-flex-col co-justify-center co-items-center pa-12"
                >
                  <span
                    class="co-text-md co-text-gray-500"
                  >
                    {{ tab.empty }}
                  </span>
                </div> -->
                <div
                  v-if="tab.pagination.length"
                  class="d-flex flex-row mx-5 mt-4 mb-8"
                >
                  <v-pagination
                    v-model="tab.pagination.current"
                    :length="tab.pagination.length"
                    :total-visible="tab.pagination.totalVisible"
                    @input="changePagination($event, tab)"
                  />
                </div>
              </v-tab-item>
            </v-tabs-items>
          </v-col>
        </v-row>
      </v-container>
    </land-section>
    <!-- <section-foot /> -->

    <!-- 图片预览对话框 -->
    <dialog-image-preview ref="dlgImgPreview" @close="onPreviewClose" />
  </section>
</template>

<script>
  import web from '@/api/web/co.web'
  import mixExhibitBanner from '@/pages/mixins/activity/mix.exhibit.banner'
  import mixExhibitBoot from '@/pages/mixins/activity/mix.exhibit.boot'

  export default {
    metaInfo: { title: '展览' },
    components: {
      // SectionFoot: () => import('@/pages/sections/Foot.vue')
      DialogImagePreview: () => import('@/pages/sections/comm/DialogImagePreview.vue')
    },
    mixins: [
      mixExhibitBanner,
      mixExhibitBoot
    ],
    data () {
      return {
      }
    },
    created () {
      this.initBannerParams({
        type: web.comm.BannerTypes.EXHIBIT_MAJOR
      })
      this.loadBanners()

      this.configContents()
      this.loadContents()
    },
    beforeDestroy () {
      // 清理键盘事件监听器
      this.removeKeyboardListeners()
    },
    methods: {
      onContent (event, tab) {
        const { item, index } = event

        console.log('Content clicked:', item, index, tab)
        console.log('Tab object:', tab)
        console.log('Tab state:', tab.state)
        console.log('Tab name:', tab.name)
        // console.log('Item cover:', item.cover)
        // console.log('Item thumbs:', item.thumbs)

        // 对于全国巡展（roadShow）和历届入选（processed），优先执行跳转逻辑
        if (tab.state === 'roadShow' || tab.name === 'processed') {
          console.log('Processing roadShow or processed item, handling content click')
          console.log('tab.state:', tab.state)
          console.log('tab.name:', tab.name)
          this.handleContentClick(event, tab)
          return
        }

        // 检查是否有图片可以预览
        if (item.cover || (item.thumbs && item.thumbs.length > 0)) {
          console.log('Showing image preview')
          this.showImagePreview(item, index, tab)
        } else {
          console.log('No images to preview, handling content click')
          // 如果没有图片，执行原有的内容处理逻辑
          this.handleContentClick(event, tab)
        }
      },

      showImagePreview (item, index, tab) {
        console.log('showImagePreview called with:', item, index, tab)

        // 收集所有图片用于预览
        const images = []

        // 添加封面图片
        if (item.cover) {
          images.push(item.cover)
          console.log('Added cover image:', item.cover)
        }

        // 添加缩略图
        if (item.thumbs && item.thumbs.length > 0) {
          // 避免重复添加封面图片
          const thumbs = item.thumbs.filter(thumb => thumb !== item.cover)
          images.push(...thumbs)
          console.log('Added thumb images:', thumbs)
        }

        console.log('Total images collected:', images)

        // 如果没有图片，直接返回
        if (images.length === 0) {
          console.log('No images found, handling content click')
          this.handleContentClick({ item, index }, tab)
          return
        }

        // 过滤掉无效的图片URL
        const validImages = images.filter(img => {
          return img && typeof img === 'string' && img.trim() !== ''
        })

        console.log('Valid images:', validImages)

        if (validImages.length === 0) {
          console.log('No valid images found, handling content click')
          this.handleContentClick({ item, index }, tab)
          return
        }

        console.log('Showing preview with images:', validImages)

        // 显示图片预览
        this.$refs.dlgImgPreview.show(validImages, 0)

        // 添加键盘事件监听
        this.addKeyboardListeners()
      },

      addKeyboardListeners () {
        // 添加键盘事件监听，支持ESC关闭和方向键导航
        const handleKeydown = (event) => {
          if (event.key === 'Escape') {
            this.$refs.dlgImgPreview.onClose()
            this.removeKeyboardListeners()
          } else if (event.key === 'ArrowLeft') {
            this.$refs.dlgImgPreview.toPrev()
          } else if (event.key === 'ArrowRight') {
            this.$refs.dlgImgPreview.toNext()
          }
        }

        document.addEventListener('keydown', handleKeydown)
        this.keyboardListener = handleKeydown
      },

      removeKeyboardListeners () {
        if (this.keyboardListener) {
          document.removeEventListener('keydown', this.keyboardListener)
          this.keyboardListener = null
        }
      },

      handleContentClick (event, tab) {
        // 直接处理点击逻辑，避免递归调用
        const { item, index } = event

        console.log('handleContentClick called:', item, index, tab)
        console.log('Item unlink:', item.unlink)
        console.log('Tab state:', tab.state)
        console.log('Complete item object:', JSON.stringify(item, null, 2))

        // 直接复制 mixin 中的逻辑
        if (tab.state === "roadShow") {
          console.log('Processing roadShow item in handleContentClick')
          console.log('item.unlink type:', typeof item.unlink)
          console.log('item.unlink value:', item.unlink)
          console.log('item.unlink length:', item.unlink ? item.unlink.length : 0)
          console.log('item.unlink truthy:', !!item.unlink)

          if (item.unlink && item.unlink.trim() !== '') {
            console.log('Opening unlink:', item.unlink)
            window.open(item.unlink, '_blank');
          } else {
            // this.$message.info("暂无链接!")
            // return; // 没有链接不做处理
            console.log('No unlink found, checking roadshowId:', item.roadshowId)
            this.$router.push({
              path: "national",
              query: {
                id: item.roadshowId
              }
            });
          }
        } else {
          console.log('Processing regular item in handleContentClick')
          console.log('tab.state:', tab.state)
          console.log('tab.name:', tab.name)
          console.log('item.activityId:', item.activityId)
          console.log('item.title:', item.title)

          const params = {
            activityId: item.activityId,
            title: item.title,
            name: tab.name
          };
          console.log('Navigating to exhibit/detail with params:', params)
          this.$router.push({
            path: "exhibit/detail",
            query: params
          });
        }
      },

      onPreviewClose () {
        this.removeKeyboardListeners()
      }
    }
  }
</script>
